import { Box, Icon, Text } from '@chakra-ui/react';
import { FaInfoCircle } from '@react-icons/all-files/fa/FaInfoCircle';

import Popover from '../../../../../../components/Popover';
import { trackCompetitorPolicyOpened } from '../../../../../../services/analytics/marketplaceEvents';
import CompetitorPolicyPopoverContent from './CompetitorPolicyPopoverContent';
import { getCompetitorTruth } from './competitorTruth';

type CompetitorTruthLineProps = {
  lienholderSlug: string | null;
  lienholderName: string | null;
  dealId: string;
  leadId: string;
};

const CompetitorTruthLine = ({
  lienholderSlug,
  lienholderName,
  dealId,
  leadId,
}: CompetitorTruthLineProps) => {
  const truth = getCompetitorTruth(lienholderSlug, lienholderName);
  if (truth == null) return null;

  return (
    <Text fontSize={{ base: '11px', md: '12px' }} color="grayLight" lineHeight="1.5" mt="8px">
      {truth.sentence}
      {' '}
      <Popover
        label={<CompetitorPolicyPopoverContent truth={truth} dealId={dealId} leadId={leadId} />}
        trigger="click"
        placement="top"
        bg="white"
        popoverBodyProps={{ color: 'charcoal', px: '20px', py: '18px' }}
        popoverContentProps={{
          w: { base: '320px', md: '460px' },
          borderColor: 'grayMediumBackground',
          borderRadius: '14px',
          boxShadow: 'lg',
        }}
        onOpen={() => trackCompetitorPolicyOpened(dealId, leadId, truth.bucket)}
      >
        <Box
          as="button"
          type="button"
          display="inline-flex"
          verticalAlign="middle"
          aria-label="Why they can't buy out your lease"
        >
          <Icon as={FaInfoCircle} color="gray.400" boxSize="13px" />
        </Box>
      </Popover>
    </Text>
  );
};

export default CompetitorTruthLine;
